import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { AccountService } from '../../../../mbs/services/account/account.service';

@Component({
    selector: 'kt-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit {
    passwordRequestGuid: string = null;
    resetPasswordForm: FormGroup;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: FormBuilder,
        private accountService: AccountService
    ) {
        this.activatedRoute.params.subscribe((params) => {
            this.passwordRequestGuid = params.guid;
        });
    }

    ngOnInit(): void {
        this.resetPasswordForm = this.fb.group({
            newPassword: ['', Validators.compose([Validators.required, Validators.minLength(4), Validators.maxLength(50)])],
            newPasswordRepeat: ['', Validators.compose([Validators.required, Validators.minLength(4), Validators.maxLength(50)])],
            passwordRequestGuid: ['', Validators.compose([Validators.required])],
        });
        this.resetPasswordForm.patchValue({ passwordRequestGuid: this.passwordRequestGuid });
    }
    resetPassword() {
        this.accountService.resetPassword(this.resetPasswordForm.value).subscribe((response) => {
            setTimeout(() => {
                this.router.navigate(['/auth/login']);
            }, 2000);
        });
    }
}
